import { Directive } from "vue";

const instances: Array<(e: Event) => void> = [];

function onDocumentClick(e: Event, el: HTMLElement, fn: (e: Event) => void) {
  const target = e.target as HTMLElement;
  if (el !== target && !el.contains(target)) {
    fn(e);
  }
}

const clickOutsideDirective = <Directive>{
  created(el, binding) {
    el.dataset.outsideClickIndex = instances.length.toString();
    const fn = binding.value as (e: Event) => void;
    const click = (e: Event) => {
      onDocumentClick(e, el, fn);
    };
    document.addEventListener("click", click);
    document.addEventListener("touchstart", click);
    instances.push(click);
  },
  beforeUnmount(el) {
    const index = parseInt(el.dataset.outsideClickIndex as string, 10);
    const handler = instances[index];
    document.removeEventListener("click", handler);
    document.removeEventListener("touchstart", handler);
    instances.splice(index, 1);
  },
};
export default clickOutsideDirective;
